/**
 * @generated SignedSource<<14090ddae5960f6f8b0b9c3b956162b2>>
 * @relayHash 928ce6c83e8118b5b0fa98a528f316f0
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/387.0.0-2022-10-14T10:32:49.088Z/NotificationsRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsRefetchQuery$variables = {
  fetchNotifications: boolean;
  first?: number | null;
  hasSessionCountryCode: boolean;
  isClient?: boolean | null;
};
export type NotificationsRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"Notifications_viewer">;
  };
};
export type NotificationsRefetchQuery = {
  response: NotificationsRefetchQuery$data;
  variables: NotificationsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchNotifications"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSessionCountryCode"
},
v3 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "isClient"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": "isAutomatedOfferNotificationDisabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableAutomatedOfferBellNotification"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchNotifications",
                "variableName": "fetchNotifications"
              },
              (v4/*: any*/),
              {
                "kind": "Variable",
                "name": "hasSessionCountryCode",
                "variableName": "hasSessionCountryCode"
              }
            ],
            "kind": "FragmentSpread",
            "name": "Notifications_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "NotificationsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasSessionCountryCode",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "regInfo",
                "args": null,
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countryCode",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v6/*: any*/),
          {
            "condition": "fetchNotifications",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "showUnreadOnly"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "notifications",
                    "value": true
                  }
                ],
                "concreteType": "ConversationConnection",
                "kind": "LinkedField",
                "name": "conversations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "apiType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inboxImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestMessage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestMessageReceivedAt",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_viewer$defer$ActivityFeed_viewer",
                "selections": [
                  {
                    "alias": "promoCodeMessaging",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "promoCodeMessaging"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/387.0.0-2022-10-14T10:32:49.088Z/NotificationsRefetchQuery",
    "metadata": {},
    "name": "NotificationsRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f0c1dff0b7d51deb69434d621e32aa28";

export default node;
